import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Modal, Button, Dropdown } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import {
	storeClientDetails,
} from 'store/reducers/mainSlice';
import { FaEdit, FaEye, FaTimesCircle } from 'react-icons/fa';

import PermissionAllowed from 'ui-component/permissions/PermissionAllowed';
import './contactdetails.scss';
import ReactSelect from 'react-select';
import { FaCircleCheck, FaUserTie, FaWhatsapp } from 'react-icons/fa6';
import { LuChevronDown, LuPhone, LuTrash2, LuBan, LuCheck } from 'react-icons/lu';
import { MdOutlineMailOutline } from 'react-icons/md';
import { BsGlobe2 } from 'react-icons/bs';
import { textToSentenceCase } from 'helpers/common.helper';
import PrivacyModeContent from 'ui-component/PrivacyModeContent';
import { Skeleton, Tooltip } from '@mui/material';
import ActionConfirmationModal from 'ui-component/confirmation-dialogs/actionConfirmationModal/ActionConfirmationModal';
import ClientPortalModel from './statusComponents/ClientPortalModal';
import { PiInfoFill } from 'react-icons/pi';
import toast from 'react-hot-toast';
import { CountriesUIFlagName } from 'ui-component/CountriesUI';
import { ColoredCheckSquareIcon, LaptopIcon } from 'ui-component/custom-icons/icons';
import useIsMobile from 'utils/isMobileUtils';

import usePageTitle from 'hooks/usePageTitle';

import SalesOrderTabComponent from './tabs/SalesOrderTabComponent'
import PurchaseOrderTabComponent from './tabs/PurchaseOrderTabComponent'
import QuotationTabComponent from './tabs/QuotationTabComponent'
import InvoiceTabComponent from './tabs/InvoiceTabComponent'
import DocumentTabComponent from './tabs/DocumentTabComponent'
import CreditNotesTabComponent from './tabs/CreditNotesTabComponent';
import StatsTabComponent from './tabs/StatsTabComponent';


// ✅ Clear
const ContactDetails = () => {
	const { id } = useParams();
	const [setPageTitle] = usePageTitle('Contact Details');
	const dispatch = useDispatch();
	const history = useNavigate();
	const [contactInfo, setContactInfo] = useState();
	const [isLoading, setIsloading] = useState(true);
	const [activeTab, setActiveTab] = useState('stats');
	const [show, setShow] = useState('');
	const [showPortal, setShowPortal] = useState('');
	const [contactStatus, setContactStatus] = useState(0);
	const [contactNewStatus, setContactNewStatus] = useState('');
	
	const [tableData, setTableData] = useState();

	const [vatFile, setVatFile] = useState({
		id: '',
		contact_id: '',
		file_name: '',
		type: '',
		vat_attachment_url: ''
	});
	const [registrationFile, setRegistrationFile] = useState({
		id: '',
		contact_id: '',
		file_name: '',
		type: '',
		registration_attachment_url: ''
	});
	const [companyLogo, setCompanyLogo] = useState({
		id: '',
		contact_id: '',
		company_logo_url: ''
	});

	const handleTab = (value) => {
		setActiveTab(value);
	};

	const getcustomerInfo = () => {
		const loading = [true, true];
		setIsloading(true);

		api.getContactbyId(id).then((res) => {
			loading[0] = false;
			setIsloading(false);

			setContactInfo(res.data);
			setContactStatus(res?.data?.status);
			if (res?.data?.status == 1) {
				setContactNewStatus('Suspend');
			} else {
				setContactNewStatus('Activate');
			}

			if (!res?.data?.client) {
				res?.data?.attachments?.map((i) => {
					if (i?.type == 'vat') {
						setVatFile({
							id: i?.id,
							contact_id: i?.contact_id,
							file_name: i?.file_name,
							type: i?.type,
							vat_attachment_url: i?.vat_attachment_url
						});
					}
					if (i?.type == 'registration') {
						setRegistrationFile({
							id: i?.id,
							contact_id: i?.contact_id,
							file_name: i?.file_name,
							type: i?.type,
							registration_attachment_url: i?.registration_attachment_url
						});
					}
					if (i?.type == 'companylogo') {
						setCompanyLogo({
							id: i?.id,
							contact_id: i?.contact_id,
							company_logo_url: i?.company_logo_url
						});
					}
				});
			} else {
				const client = res?.data?.client;
				if (client) {
					if (client.vat_code) {
						const fileName = client?.vat_doc?.split('/').pop(); // Extracts the filename and extension
						setVatFile({
							id: client.id,
							contact_id: '',
							file_name: fileName, // Use the extracted filename
							type: 'vat',
							vat_attachment_url: client.vat_doc_url
						});
					}
					const fileNameReg = client.registration_doc_url.split('/').pop();
					setRegistrationFile({
						id: client.id,
						contact_id: '',
						file_name: fileNameReg,
						type: 'registration',
						registration_attachment_url: client.registration_doc_url
					});
				}
			}
		});
	};

	const handleClientPortalSubmit = (data) => {
		toast.promise(
			api.addClientPortal(data).then((res) => {
				if (res.message) {
					history('/contacts');
				}
			}),
			{
				loading: 'Creating User Portal...',
				success: (data) => `${data.message}`,
				error: <b>Failed to create user portal</b>
			}
		);
	};

	const handleClose = () => setShow('');
	const handleClosePortal = () => setShowPortal('');

	const handleDelete = (id) => {
		showConfirmationDialog(
			`Delete Contact?`,
			`Are you sure you want to delete ${contactInfo?.name}?`,
			() => {
				handleDeleteSubmit(id);
				handleCloseConfirmationDialog();
			},
			handleCloseConfirmationDialog
		);
	};

	const handleDeleteSubmit = (id) => {
		toast.promise(
			api.deleteContact(id).then((res) => {
				if (res.status) {
					history('/contacts');
				}

				// setIsDisable(false);
				return res?.status ? res : null;
			}),
			{
				loading: 'Updating Status...',
				success: (data) => `${data.message}`,
				error: <b>Failed to update status</b>
			}
		);
	};

	const [confirmationDialog, setConfirmationDialog] = useState({
		show: false,
		message: '',
		title: '',
		handleConfirm: () => {},
		handleClose: () => {}
	});

	const showConfirmationDialog = (title, message = '', onConfirm = () => {}, onClose = () => {}) => {
		setConfirmationDialog({
			show: true,
			message: message,
			title: title,
			handleConfirm: onConfirm,
			handleClose: onClose
		});
	};


	const handleCloseConfirmationDialog = () => {
		setConfirmationDialog({
			show: false,
			message: '',
			title: '',
			handleConfirm: () => {},
			handleClose: () => {}
		});
	};

	const handleUpdateStatusSubmit = () => {
		toast.promise(
			api.updateContactStatus(id, contactStatus == 1 ? false : true).then((res) => {
				if (res.status) {
					// setIsInProgress(true);

					setContactStatus(res?.data?.status);
					if (res?.data == 'activated') {
						setContactNewStatus('Suspend');
						setContactStatus(1);
					} else {
						setContactNewStatus('Activate');
						setContactStatus(0);
					}
				}

				// setIsDisable(false);
				return res?.status ? res : null;
			}),
			{
				loading: 'Updating Status...',
				success: (data) => `${data.message}`,
				error: <b>Failed to update status</b>
			}
		);
	};

	const handleUpdateStatus = (id) => {
		showConfirmationDialog(
			`${contactNewStatus} Contact?`,
			`Are you sure you want to ${contactNewStatus.toLowerCase()} ${contactInfo?.name}?`,
			() => {
				handleUpdateStatusSubmit();
				handleCloseConfirmationDialog();
			},
			handleCloseConfirmationDialog
		);
	};

	useEffect(() => {
		getcustomerInfo();
	}, []);

	const isMobile = useIsMobile();

	const [selectedMobileTab, setSelectedMobileTab] = useState('profile');


	const getClientPortalAccessToken = (id) => {

		toast.promise(
			api.getClientPortalAccessToken(id).then((res) => {
				if (res?.status) {
					const clientToken = res?.data?.client_token;
					dispatch(storeClientDetails({ ...res, stayLoggedIn: true }));
					toast.success('Client login successfully');
					if (res?.data?.is_approved === 2) {
						openInNewTab('/client/dashboard');
					} else if (res?.data?.is_approved === 0) {
						openInNewTab('/client/company-details');
					} else {
						openInNewTab('/client/company-verified');
					}
					return res; // success
				} else {
					throw new Error(res?.message || 'Failed to access client portal');
				}
			}),
			{
				loading: 'Accessing Client Portal...',
				success: (data) => `${data.message || 'Accessed client portal.'}`,
				error: <b>Failed to access client portal</b>
			}
		);
	}
    const openInNewTab = (url) => {
        const a = document.createElement('a');
        a.href = url;
        a.target = '_blank';
        a.rel = 'noopener noreferrer';
        a.click();
    };

	return (
		<>
			{!isMobile ? (
				<div className="row">
					<div className="col-12">
						<div className="flex gap-3 justify-content-between">
							<div
								style={{
									width: '600px',
									padding: '10px',
									height: 'calc(100vh - 100px)',
									overflowY: 'auto',
									scrollbarWidth: 'thin',
									scrollbarColor: 'transparent transparent',
									marginTop: '20px'
								}}
							>
								{isLoading ? (
									<div className="w-full flex justify-content-center">
										<div style={{ width: '250px', marginBottom: '10px' }}>
											<Skeleton variant="rounded" width={'100%'} height={90} style={{ borderRadius: '32px' }} />
										</div>
									</div>
								) : (
									companyLogo?.company_logo_url && (
										<div className="row" style={{ marginBottom: '10px' }}>
											<div className="col-12 text-center">
												<img src={companyLogo?.company_logo_url} style={{ width: '200px' }} />
											</div>
										</div>
									)
								)}
								<div className="row mb-3">
									<div className="col-12 flex justify-content-center">
										<h5 className="fw-600" style={{ textAlign: 'center', margin: 0 }}>
											{isLoading ? (
												<div style={{ width: '250px' }}>
													<Skeleton variant="rounded" width={'100%'} height={25} style={{ borderRadius: '32px' }} />
												</div>
											) : (
												contactInfo?.name											)}
										</h5>
									</div>
								</div>
								<div className="row mb-3">
									<div className="col-12 text-center">
										<div className="contact-head-btns flex justify-content-center gap-2">
											{isLoading ? (
												<div style={{ width: '250px' }}>
													<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
												</div>
											) : (
												<>
													<a href={contactInfo?.contact_phone ? 'tel:' + contactInfo?.contact_phone : '#'} target="_blank">
														<Tooltip title="Call" arrow placement="top">
															<span className="btnEdit plain-iconbtn active">
																<LuPhone />
															</span>
														</Tooltip>
													</a>

													<a href={contactInfo?.email ? 'mailto:' + contactInfo?.email : '#'} target="_blank">
														<Tooltip title="Email" arrow placement="top">
															<span className="btnEdit plain-iconbtn active">
																<MdOutlineMailOutline />
															</span>
														</Tooltip>
													</a>
													<a href={contactInfo?.company_website || '#'}
														target={contactInfo?.company_website ? '_blank' : undefined}
														className={contactInfo?.company_website ? '' : ' cursor-disabled text-gray-600'}
													>
														<Tooltip title={`Go to Contact Website`} arrow placement="top">
															<span className={`btnEdit plain-iconbtn ${contactInfo?.company_website ? 'active' : 'disabled'}`}>
																<BsGlobe2 />
															</span>
														</Tooltip>
													</a>
													<div
														className={contactInfo?.has_client_portal ? '' : 'cursor-disabled text-gray-600'}
														onClick={() => {
															if (contactInfo?.has_client_portal) {
																getClientPortalAccessToken(contactInfo?.id)
															}
														}}
													>
														<Tooltip title={`${contactInfo?.has_client_portal ? 'Access Client Portal' : 'No Client Portal'}`} arrow placement="top">
															<span className={`btnEdit plain-iconbtn ${contactInfo?.has_client_portal ? 'active' : 'disabled'}`}>
																<LaptopIcon height={'16'} width={'16'} />
															</span>
														</Tooltip>
													</div>
													<PermissionAllowed permissions={['Suspend/Activate Contact (Button)']}>
														<Tooltip title={`${contactNewStatus} Contact`} arrow placement="top">
															<span
																className="btnEdit plain-iconbtn active"
																onClick={() => {
																	handleUpdateStatus(contactInfo?.id);
																}}
															>
																{contactStatus == 1 ? <LuBan /> : <LuCheck />}
															</span>
														</Tooltip>
													</PermissionAllowed>
													<PermissionAllowed permissions={['Delete Contact (Action)']}>
														<Tooltip title="Delete Contact" arrow placement="top">
															<span
																className="btnEdit plain-iconbtn active"
																onClick={() => {
																	handleDelete(contactInfo?.id);
																}}
															>
																<LuTrash2 />
															</span>
														</Tooltip>
													</PermissionAllowed>
												</>
											)}
										</div>
									</div>
								</div>
								<div className="row form-group" style={{ marginBottom: '20px' }}>
									<div className="col-12 flex justify-content-center">
										{isLoading ? (
											<div style={{ width: '150px' }}>
												<Skeleton variant="rounded" width={'100%'} height={35} style={{ borderRadius: '32px' }} />
											</div>
										) : (
											<div
												className="text-gray-800 flex gap-2"
												style={{
													border: '1px solid #e0e0e0',
													padding: '5px 15px',
													borderRadius: '12px'
												}}
											>
												<div>
													<FaUserTie />
												</div>
												<div>{contactInfo?.sales_manager}</div>
											</div>
										)}
									</div>
								</div>
								<div style={{ padding: '0 10px' }}>
									<div className="row">
										<div className="w-full flex justify-content-between align-items-center gap-4" style={{ padding: '0 10px' }}>
											<div className="w-full">
												<div className="fw-500">
													{isLoading ? (
														<div style={{ width: '200px' }}>
															<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
														</div>
													) : (
														'Complete your profile'
													)}
												</div>
												<div className="contact-progress mb-3" style={{ marginTop: '10px' }}>
													<div
														className="contact-progress-bar"
														style={{ width: `${isLoading ? '0' : `${contactInfo?.verification_level?.percentage}%`}` }}
													></div>
												</div>
											</div>
											<div className="text-gray-600" style={{ marginTop: '15px' }}>
												{isLoading ? (
													<div style={{ width: '50px' }}>
														<Skeleton variant="rounded" width={'100%'} height={17} style={{ borderRadius: '32px' }} />
													</div>
												) : (
													`${contactInfo?.verification_level?.percentage}%`
												)}
											</div>
										</div>
									</div>

									<div className="row mb-3">
										<div className="col-5 text-gray-600">
											{isLoading ? (
												<div style={{ width: '120px' }}>
													<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
												</div>
											) : (
												'Type'
											)}
										</div>
										<div className="col-7 fw-400">
											{isLoading ? (
												<div style={{ width: '100%' }}>
													<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
												</div>
											) : (
												contactInfo?.contact_type ? (
													contactInfo?.contact_type === 'customer'
														? 'Customer'
														: contactInfo?.contact_type === 'supplier'
														? 'Supplier'
														: contactInfo?.contact_type === 'transit-company'
														? 'Transit Company'
														: contactInfo?.contact_type === 'logistic'
														? 'Logistic'
														: ''
												) : (
													'---'
												)
											)}
										</div>
									</div>
									<div className="row mb-3">
										<div className="col-5 text-gray-600">
											{isLoading ? (
												<div style={{ width: '120px' }}>
													<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
												</div>
											) : (
												'Email Address'
											)}
										</div>
										<div className="col-7 fw-400">
											{isLoading ? (
												<div style={{ width: '100%' }}>
													<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
												</div>
											) : (
												`${contactInfo?.email ?? '---'}`
											)}
										</div>
									</div>
									<div className="row mb-3">
										<div className="col-5 text-gray-600">
											{isLoading ? (
												<div style={{ width: '120px' }}>
													<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
												</div>
											) : (
												'Phone Number'
											)}
										</div>
										<div className="col-7 fw-400">
											{isLoading ? (
												<div style={{ width: '100%' }}>
													<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
												</div>
											) : (
												<PrivacyModeContent>
													{contactInfo?.contact_phone ? (
														<a
															href={contactInfo?.contact_phone ? 'tel:' + contactInfo?.contact_phone : '#'}
															target="_blank"
															className="flex gap-1"
															style={{
																textDecoration: 'none'
															}}
														>
															<div style={{ marginTop: '-1px' }}>
																<LuPhone />
															</div>
															<div>{contactInfo?.contact_phone}</div>
														</a>
													) : (
														'---'
													)}
												</PrivacyModeContent>
											)}
										</div>
									</div>
									<div className="row mb-3">
										<div className="col-5 text-gray-600">
											{isLoading ? (
												<div style={{ width: '120px' }}>
													<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
												</div>
											) : (
												'Whatsapp Number'
											)}
										</div>
										<div className="col-7 fw-400">
											{isLoading ? (
												<div style={{ width: '100%' }}>
													<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
												</div>
											) : (
												<PrivacyModeContent>
													{contactInfo?.contact_whatsapp ? (
														<a
															href={`https://wa.me/${contactInfo?.contact_whatsapp?.replace(/\s+/g, '')?.replace(/\+/g, '')}`}
															target="_blank"
															className="flex gap-1"
															style={{
																textDecoration: 'none'
															}}
														>
															<div style={{ marginTop: '-1px' }}>
																<FaWhatsapp />
															</div>
															<div>{contactInfo?.contact_whatsapp}</div>
														</a>
													) : (
														'---'
													)}
												</PrivacyModeContent>
											)}
										</div>
									</div>
									<div className="row mb-3">
										<div className="col-5 text-gray-600">
											{isLoading ? (
												<div style={{ width: '120px' }}>
													<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
												</div>
											) : (
												'VAT Number'
											)}
										</div>
										<div className="col-7 fw-400 flex gap-1">
											{isLoading ? (
												<div style={{ width: '100%' }}>
													<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
												</div>
											) : (
												contactInfo?.is_vat_applicable === 'Not Applicable' ? (
													<div className="flex gap-2 align-items-center justify-content-start">
														<div>
															<ColoredCheckSquareIcon height="15px" width="15px" />
														</div>
														<div style={{ marginBottom: '-1px' }}>Not Applicable</div>
													</div>
												) : (
													contactInfo?.is_vat_applicable === 'Not Applicable' ? (
														<div className="flex gap-2 align-items-center justify-content-start">
															<div>
																<ColoredCheckSquareIcon height="15px" width="15px" />
															</div>
															<div style={{ marginBottom: '-1px' }}>Not Applicable</div>
														</div>
													) : (
														<>
															<PrivacyModeContent>{contactInfo?.vat_number || '-'}</PrivacyModeContent>

															{contactInfo?.vat_number && (
																contactInfo?.is_vat_verified ? (
																	<span className="text-success">
																		<FaCircleCheck />
																	</span>
																) : (
																	<span className="text-danger">
																		<FaTimesCircle />
																	</span>
																)
															)}
														</>
													)
												)
											)}
										</div>
									</div>
									<div className="row mb-3">
										<div className="col-5 text-gray-600">
											{isLoading ? (
												<div style={{ width: '120px' }}>
													<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
												</div>
											) : (
												'VAT File'
											)}
										</div>
										<div className="col-7 fw-400">
											{isLoading ? (
												<div style={{ width: '100%' }}>
													<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
												</div>
											) : (
												contactInfo?.is_vat_applicable === 'Not Applicable' ? (
													<>
														<div className="flex gap-2 align-items-center justify-content-start">
															<div>
																<ColoredCheckSquareIcon height="15px" width="15px" />
															</div>
															<div style={{ marginBottom: '-1px' }}>Not Applicable</div>
														</div>
													</>
												) : (
													vatFile?.file_name ? (
														<a href={vatFile?.vat_attachment_url} target="_blank">
															<FaEye /> View
														</a>
													) : (
														'---'
													)
												)
											)}
										</div>
									</div>
									<div className="row mb-3">
										<div className="col-5 text-gray-600">
											{isLoading ? (
												<div style={{ width: '120px' }}>
													<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
												</div>
											) : (
												'Registration Number'
											)}
										</div>
										<div className="col-7 fw-400">
											{isLoading ? (
												<div style={{ width: '100%' }}>
													<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
												</div>
											) : (
												<PrivacyModeContent>{contactInfo?.registration_number || '---'}</PrivacyModeContent>
											)}
										</div>
									</div>
									<div className="row mb-3">
										<div className="col-5 text-gray-600">
											{isLoading ? (
												<div style={{ width: '120px' }}>
													<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
												</div>
											) : (
												'Registration File'
											)}
										</div>
										<div className="col-7 fw-400">
											{isLoading ? (
												<div style={{ width: '100%' }}>
													<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
												</div>
											) : (
												registrationFile?.file_name ? (
													<a href={registrationFile?.registration_attachment_url} target="_blank">
														<FaEye /> View
													</a>
												) : (
													'---'
												)
											)}
										</div>
									</div>
									<div className="row mb-3">
										<div className="col-5 text-gray-600">
											{isLoading ? (
												<div style={{ width: '120px' }}>
													<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
												</div>
											) : (
												'Establishment Year'
											)}
										</div>
										<div className="col-7 fw-400">
											{isLoading ? (
												<div style={{ width: '100%' }}>
													<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
												</div>
											) : (
												contactInfo?.establishment_year || '---'
											)}
										</div>
									</div>
									<div className="row mb-3">
										<div className="col-5 text-gray-600">
											{isLoading ? (
												<div style={{ width: '120px' }}>
													<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
												</div>
											) : (
												'Turnover'
											)}
										</div>
										<div className="col-7 fw-400">
											{isLoading ? (
												<div style={{ width: '100%' }}>
													<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
												</div>
											) : (
												contactInfo?.company_turnover?.name || '---'
											)}
										</div>
									</div>
									<div className="row mb-3">
										<div className="col-5 text-gray-600">
											{isLoading ? (
												<div style={{ width: '120px' }}>
													<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
												</div>
											) : (
												'Company Activity'
											)}
										</div>
										<div className="col-7 fw-400">
											{isLoading ? (
												<div style={{ width: '100%' }}>
													<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
												</div>
											) : (
												contactInfo?.company_activity?.name || '---'
											)}
										</div>
									</div>
									<div className="row mb-3">
										<div className="col-5 text-gray-600">
											{isLoading ? (
												<div style={{ width: '120px' }}>
													<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
												</div>
											) : (
												'Interest'
											)}
										</div>
										<div className="col-7 fw-400">
											{isLoading ? (
												<div style={{ width: '100%' }}>
													<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
												</div>
											) : (
												contactInfo?.interests?.length > 0 ? (
													contactInfo?.interests?.map((int, ind) =>
														ind == contactInfo?.interests?.length - 1 ? int?.name : int?.name + ', '
													)
												) : (
													'---'
												)
											)}
										</div>
									</div>
									<div className="row mb-3">
										<div className="col-5 text-gray-600">
											{isLoading ? (
												<div style={{ width: '120px' }}>
													<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
												</div>
											) : (
												'Specifications'
											)}
										</div>
										<div className="col-7 fw-400">
											{isLoading ? (
												<div style={{ width: '100%' }}>
													<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
												</div>
											) : (
												contactInfo?.specifications?.length > 0
													? contactInfo?.specifications?.map((int, ind) =>
															ind == contactInfo?.specifications?.length - 1 ? int?.name : int?.name + ', '
													  )
														: '---'
											)}
										</div>
									</div>
									<div className="row mb-3">
										<div className="col-5 text-gray-600">
											{isLoading ? (
												<div style={{ width: '120px' }}>
													<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
												</div>
											) : (
												'Billing Address'
											)}
										</div>
										<div className="col-7 fw-400">
											{isLoading ? (
												<div style={{ width: '100%' }}>
													<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
												</div>
											) : (
												<>
													{contactInfo?.address?.address}, {contactInfo?.address?.city}, {contactInfo?.address?.zipcode} <br />
													{contactInfo?.address?.country?.name}
												</>
											)}
										</div>
									</div>
									<div className="row mb-3">
										<div className="col-5 text-gray-600">
											{isLoading ? (
												<div style={{ width: '120px' }}>
													<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
												</div>
											) : (
												'Shipping Address'
											)}
										</div>
										<div className="col-7 fw-400">
											{isLoading ? (
												<div style={{ width: '100%' }}>
													<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
												</div>
											) : (
												<>
													{contactInfo?.shipping?.address}, {contactInfo?.shipping?.city}, {contactInfo?.shipping?.zipcode} <br />
													{contactInfo?.shipping?.country?.name}
												</>
											)}
										</div>
									</div>
									{!isLoading && (
										<div className="contact-details-section">
											<div className="contact-detail-side">
												<div className="contact-cps">
													<div className="contact-cp">
														<label className="cp-key">Contact 01</label>
														<p className="cp-name">
															<PrivacyModeContent>{contactInfo?.contact_name || '-'}</PrivacyModeContent>
														</p>
														<p className="cp-email">
															<PrivacyModeContent>{contactInfo?.email || '-'}</PrivacyModeContent>
														</p>
														<p className="cp-mobile">
															<PrivacyModeContent>{contactInfo?.contact_phone || '-'}</PrivacyModeContent>
														</p>

														<div className="contact-cp-actions">
															<a href={contactInfo?.contact_phone ? 'tel:' + contactInfo?.contact_phone : '#'} target="_blank">
																<span className="btnEdit plain-iconbtn active contact-cp-buttons">
																	<LuPhone size={isMobile ? 18 : 12} />
																</span>
															</a>
															<a
																href={
																	contactInfo?.contact_whatsapp
																		? 'https://wa.me/' + contactInfo?.contact_whatsapp?.replace('+', '')
																		: '#'
																}
															>
																<span className="btnEdit plain-iconbtn active contact-cp-buttons">
																	<FaWhatsapp size={isMobile ? 18 : 12} />
																</span>
															</a>
															<a href={contactInfo?.email ? 'mailto:' + contactInfo?.email : '#'} target="_blank">
																<span className="btnEdit plain-iconbtn active contact-cp-buttons">
																	<MdOutlineMailOutline size={isMobile ? 18 : 12} />
																</span>
															</a>
														</div>
													</div>
												</div>
											</div>
										</div>
									)}
								</div>
							</div>
							<div style={{ width: '100%' }}>
								<div className="flex justify-content-between align-items-center" style={{ padding: '10px' }}>
									<ul className="topListCom mini" style={{ paddingInline: '10px', paddingBottom: '5px' }}>
										<li
											className={`${activeTab === 'stats' ? 'active' : ''}`}
											onClick={() => {
												handleTab('stats');
											}}
										>
											Stats
										</li>
										{
											contactInfo?.contact_type === 'supplier' ? (
												<li
													className={`${activeTab === 'Purchase Orders' ? 'active' : ''}`}
													onClick={() => {
														handleTab('Purchase Orders');
													}}
												>
													Purchase Orders
												</li>
											) : (
												<>
													<li
														className={`${activeTab === 'Quotations' ? 'active' : ''}`}
														onClick={() => {
															handleTab('Quotations');
														}}
													>
														Quotations
													</li>
													<li
														className={`${activeTab === 'Sales Orders' ? 'active' : ''}`}
														onClick={() => {
															handleTab('Sales Orders');
														}}
													>
														Sales Orders
													</li>
													<li
														className={`${activeTab === 'Invoices' ? 'active' : ''}`}
														onClick={() => {
															handleTab('Invoices');
														}}
													>
														Invoices
													</li>
													<li
														className={`${activeTab === 'Credit Notes' ? 'active' : ''}`}
														onClick={() => {
															handleTab('Credit Notes');
														}}
													>
														Credit Notes
													</li>
												</>
											)
										}
										<li
											className={`${activeTab === 'Documents' ? 'active' : ''}`}
											onClick={() => {
												handleTab('Documents');
											}}
										>
											Documents
										</li>
										<li
											className={`${activeTab === 'History' ? 'active' : ''}`}
											onClick={() => {
												handleTab('History');
											}}
										>
											History
										</li>

									</ul>
									<div className="contact-actions-area" style={{ marginTop: '-8px' }}>
										<PermissionAllowed permissions={['Edit Contact Details (Action)']}>
											<Link
												className="btn btn-primary btn-outlined-main white-var"
												style={{ minWidth: '65px', padding: '3px 10px' }}
												to={`/contacts/edit/${id}`}
											>
												<FaEdit /> Edit
											</Link>
										</PermissionAllowed>
										<PermissionAllowed permissions={['Delete Contact (Button)']} hasSome>
											<Dropdown className="btnDel iconbtn" align={'end'}>
												<Dropdown.Toggle as="span">
													<Link to={''} className="btn btn-primary btn-outlined-main white-var" style={{ minWidth: 'unset' }}>
														Extra <LuChevronDown />
													</Link>
												</Dropdown.Toggle>
												<PermissionAllowed permissions={['Delete Contact (Button)']}>
													<Dropdown.Menu>
														<Dropdown.Item>Delete</Dropdown.Item>
													</Dropdown.Menu>
												</PermissionAllowed>
											</Dropdown>
										</PermissionAllowed>
									</div>
								</div>

								<div
									className={activeTab === 'stats' ? '' : 'card bg-white table-card'}
									style={{
										boxShadow: '0px 3px 9px #cfcfcf !important',
										marginTop: '-17px',
										height: 'calc(100vh - 128px)'
									}}
								>
									{activeTab === 'stats' && (
										<StatsTabComponent id={id} contactType={contactInfo?.contact_type} />
									)}
									{
										contactInfo?.contact_type === 'supplier' ? (
											activeTab === 'Purchase Orders' && (
												<PurchaseOrderTabComponent id={contactInfo?.id} />
											)
										) : (
											<>
												{activeTab === 'Quotations' && (
													<QuotationTabComponent id={contactInfo?.id} />
												)}
												{activeTab === 'Sales Orders' && (
													<SalesOrderTabComponent id={contactInfo?.id} />
												)}
												{activeTab === 'Invoices' && (
													<InvoiceTabComponent id={contactInfo?.id} />
												)}
												{activeTab === 'Credit Notes' && (
													<CreditNotesTabComponent id={contactInfo?.id} />
												)}
											</>
										)
									}
									{activeTab === 'Documents' && (
										<DocumentTabComponent attachments={contactInfo?.attachments} />
									)}
								</div>
							</div>
						</div>
					</div>
				</div>
			) : (
				<div className={`row m-0 p-0 contact-details-section ${isMobile ? '' : ' mt-4 '}`}>
					<div className="col-12 col-md-3 col-lg-3 m-0 p-0">
						<div className="show-on-mobile new-page-header" style={{ position: 'relative' }}>
							<div className="header-bubble" />
							<div className="d-flex flex-column gap-2 " style={{ position: 'relative', zIndex: 1, paddingTop: 10, width: '100%' }}>
								<div
									style={{
										position: 'relative',
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
										marginBottom: 8,
										minHeight: 38 // ensures enough height for the button
									}}
								>
									{' '}
									<button
										type="button"
										aria-label="Back"
										onClick={() => history(-1)}
										className="circle-back-btn"
										style={{
											position: 'absolute',
											left: 20,
											top: '50%',
											transform: 'translateY(-50%)'
										}}
									>
										{/* Replace with your fi arrow icon, example below */}
										<svg width="22" height="22" fill="none" viewBox="0 0 24 24">
											<path d="M15 19l-7-7 7-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
										</svg>
									</button>
									<h5 style={{ textAlign: 'center', flex: 1, margin: 0 }}>{contactInfo?.name}</h5>
								</div>
								<div
									style={{
										display: 'flex',
										width: '100%',
										justifyContent: 'center',
										paddingBottom: 0,
										paddingTop: 0,
										paddingLeft: 20,
										paddingRight: 20
									}}
								>
									<div className="header-option-container">
										<div
											className={`header-option ${selectedMobileTab === 'profile' ? 'active' : ''}`}
											onClick={() => {
												setSelectedMobileTab('profile');
											}}
										>
											Profile
										</div>
										<div
											className={`header-option ${selectedMobileTab === 'business' ? 'active' : ''}`}
											onClick={() => {
												setSelectedMobileTab('business');
											}}
										>
											Business
										</div>
									</div>
								</div>
							</div>
						</div>
						{(!isMobile || (isMobile && selectedMobileTab === 'profile')) && (
							<div
								className={`${
									isMobile
										? 'mobile-scroll-container contact-detail-side no-padding-inline'
										: 'card shadow-sm rounded bg-white p-3 contact-detail-side '
								}`}
							>
								<div className="contact-detail-head" style={{ paddingTop: 10 }}>
									<h2 className="contact-name">
										{isLoading ? (
											<div style={{ width: '250px' }}>
												<Skeleton variant="rounded" width={'100%'} height={25} style={{ borderRadius: '32px' }} />
											</div>
										) : (
											<PrivacyModeContent>{contactInfo?.name}</PrivacyModeContent>
										)}
									</h2>
									{isLoading ? (
										<div style={{ width: '250px' }}>
											<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
										</div>
									) : (
										<div className="contact-head-btns">
											<a href={contactInfo?.contact_phone ? 'tel:' + contactInfo?.contact_phone : '#'} target="_blank">
												<Tooltip title="Call" arrow placement="top">
													<span className="btnEdit plain-iconbtn">
														<LuPhone />
													</span>
												</Tooltip>
											</a>

											<a href={contactInfo?.email ? 'mailto:' + contactInfo?.email : '#'} target="_blank">
												<Tooltip title="Email" arrow placement="top">
													<span className="btnEdit plain-iconbtn">
														<MdOutlineMailOutline />
													</span>
												</Tooltip>
											</a>
											<a href={contactInfo?.company_website || '#'} target="_blank">
												<Tooltip title="Go to Contact Website" arrow placement="top">
													<span className="btnEdit plain-iconbtn">
														<BsGlobe2 />
													</span>
												</Tooltip>
											</a>
											<PermissionAllowed permissions={['Suspend/Activate Contact (Button)']}>
												<Tooltip title={`${contactNewStatus} Contact`} arrow placement="top">
													<span
														className="btnEdit plain-iconbtn"
														onClick={() => {
															handleUpdateStatus(contactInfo?.id);
														}}
													>
														{contactStatus == 1 ? <LuBan /> : <LuCheck />}
													</span>
												</Tooltip>
											</PermissionAllowed>
											<PermissionAllowed permissions={['Delete Contact (Action)']}>
												<Tooltip title="Delete Contact" arrow placement="top">
													<span
														className="btnEdit plain-iconbtn"
														onClick={() => {
															handleDelete(contactInfo?.id);
														}}
													>
														<LuTrash2 />
													</span>
												</Tooltip>
											</PermissionAllowed>
										</div>
									)}
									{isLoading ? (
										<div style={{ width: '150px' }}>
											<Skeleton variant="rounded" width={'100%'} height={35} style={{ borderRadius: '12px' }} />
										</div>
									) : (
										<p
											className="contact-sm show-on-mobile"
											style={{ border: '1px solid #e0e4e9', padding: '5px 10px', borderRadius: '8px' }}
										>
											<FaUserTie /> {contactInfo?.sales_manager}
										</p>
									)}
								</div>
								<div className="contact-detail-item">
									<label>Type</label>
									{isLoading ? (
										<div style={{ width: '160px' }}>
											<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
										</div>
									) : (
										textToSentenceCase(contactInfo?.contact_type) != 'falsefalse' ? (
											<p>{textToSentenceCase(contactInfo?.contact_type)?.replace('-', ' ') || '-'}</p>
										) : (
											<p>---</p>
										)
									)}
								</div>
								<div className="contact-detail-item">
									<label>VAT Number</label>
									{isLoading ? (
										<div style={{ width: '160px' }}>
											<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
										</div>
									) : (
										<p className="vat">
											{contactInfo?.is_vat_applicable === 'Not Applicable' ? (
												<div className="flex gap-2 align-items-center justify-content-start">
													<div>
														<ColoredCheckSquareIcon height="15px" width="15px" />
													</div>
													<div style={{ marginBottom: '-1px' }}>Not Applicable</div>
												</div>
											) : (
												<>
													<PrivacyModeContent>{contactInfo?.vat_number || '-'}</PrivacyModeContent>

													{contactInfo?.vat_number && (
														contactInfo?.is_vat_verified ? (
															<span className="text-success">
																<FaCircleCheck />
															</span>
														) : (
															<span className="text-danger">
																<FaTimesCircle />
															</span>
														)
													)}
												</>
											)}
										</p>
									)}
								</div>
								<div className="contact-detail-item">
									<label>VAT File</label>
									{isLoading ? (
										<div style={{ width: '160px' }}>
											<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
										</div>
									) : (
										<p className="vat">
											{contactInfo?.is_vat_applicable === 'Not Applicable' ? (
												<div className="flex gap-2 align-items-center justify-content-start">
													<div>
														<ColoredCheckSquareIcon height="15px" width="15px" />
													</div>
													<div style={{ marginBottom: '-1px' }}>Not Applicable</div>
												</div>
											) : (
												vatFile?.file_name ? (
													<a href={vatFile?.vat_attachment_url} target="_blank">
														<PrivacyModeContent>{vatFile?.file_name}</PrivacyModeContent>
													</a>
												) : (
													'---'
												)
											)}
										</p>
									)}
								</div>
								<div className="contact-detail-item">
									<label>Registration Number</label>
									{isLoading ? (
										<div style={{ width: '160px' }}>
											<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
										</div>
									) : (
										<p>
											<PrivacyModeContent>{contactInfo?.registration_number || '-'}</PrivacyModeContent>
										</p>
									)}
								</div>
								<div className="contact-detail-item">
									<label>Registration File</label>
									{isLoading ? (
										<div style={{ width: '160px' }}>
											<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
										</div>
									) : (
										<p className="vat">
											{registrationFile?.file_name ? (
												<a href={registrationFile?.registration_attachment_url} target="_blank">
													<PrivacyModeContent>{registrationFile?.file_name}</PrivacyModeContent>
												</a>
											) : (
												'---'
											)}
										</p>
									)}
								</div>
								<div className="contact-detail-item">
									<label>Email address</label>
									{isLoading ? (
										<div style={{ width: '160px' }}>
											<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
										</div>
									) : (
										<p style={{ wordBreak: 'break-all', overflowWrap: 'break-word' }}>
											<PrivacyModeContent>{contactInfo?.email || '-'}</PrivacyModeContent>
										</p>
									)}
								</div>
								<div className="contact-detail-item">
									<label>Whatsapp Number</label>
									{isLoading ? (
										<div style={{ width: '160px' }}>
											<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
										</div>
									) : (
										<p>
											<PrivacyModeContent>
												{contactInfo?.contact_whatsapp ? (
													<a
														href={`https://wa.me/${contactInfo?.contact_whatsapp?.replace(/\s+/g, '')?.replace(/\+/g, '')}`}
														target="_blank"
														className="flex gap-1"
														style={{
															textDecoration: 'none'
														}}
													>
														<div style={{ marginTop: '-1px' }}>
															<FaWhatsapp />
														</div>
														<div>{contactInfo?.contact_whatsapp}</div>
													</a>
												) : (
													'---'
												)}
											</PrivacyModeContent>
										</p>
									)}
								</div>
								<div className="contact-detail-item">
									<label>Phone Number</label>
									{isLoading ? (
										<div style={{ width: '160px' }}>
											<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
										</div>
									) : (
										<p>
											<PrivacyModeContent>
												{contactInfo?.contact_phone ? (
													<a
														href={contactInfo?.contact_phone ? 'tel:' + contactInfo?.contact_phone : '#'}
														target="_blank"
														className="flex gap-1"
														style={{
															textDecoration: 'none'
														}}
													>
														<div style={{ marginTop: '-1px' }}>
															<LuPhone />
														</div>
														<div>{contactInfo?.contact_phone}</div>
													</a>
												) : (
													'---'
												)}
											</PrivacyModeContent>
										</p>
									)}
								</div>
								<div className="contact-detail-item">
									<label>Establishment Year </label>
									{isLoading ? (
										<div style={{ width: '160px' }}>
											<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
										</div>
									) : (
										<p>{contactInfo?.establishment_year || '---'}</p>
									)}
								</div>
								<div className="contact-detail-item">
									<label>Turnover </label>
									{isLoading ? (
										<div style={{ width: '160px' }}>
											<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
										</div>
									) : (
										<p>{contactInfo?.company_turnover?.name || '---'}</p>
									)}
								</div>
								<div className="contact-detail-item">
									<label>Company Activity </label>
									{isLoading ? (
										<div style={{ width: '160px' }}>
											<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
										</div>
									) : (
										<p>{contactInfo?.company_activity?.name || '---'}</p>
									)}
								</div>
								<div className="contact-detail-item">
									<label>Interest </label>
									{isLoading ? (
										<div style={{ width: '160px' }}>
											<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
										</div>
									) : (
										<p>
											{contactInfo?.interests?.length > 0 ? (
												contactInfo?.interests?.map((int, ind) =>
													ind == contactInfo?.interests?.length - 1 ? int?.name : int?.name + ', '
												)
											) : (
												'---'
											)}
										</p>
									)}
								</div>
								<div className="contact-detail-item">
									<label>Specifications </label>
									{isLoading ? (
										<div style={{ width: '160px' }}>
											<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
										</div>
									) : (
										<p>
											{contactInfo?.specifications?.length > 0
												? contactInfo?.specifications?.map((int, ind) =>
														ind == contactInfo?.specifications?.length - 1 ? int?.name : int?.name + ', '
													)
												: '-'}
										</p>
									)}
								</div>
								<div className="contact-detail-item">
									<label>Country </label>
									{isLoading ? (
										<div style={{ width: '160px' }}>
											<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
										</div>
									) : (
										<p>
											{contactInfo?.address?.country?.name ? (
												<CountriesUIFlagName countryName={contactInfo?.address?.country?.name} />
											) : contactInfo?.shipping?.country?.name ? (
												<CountriesUIFlagName countryName={contactInfo?.shipping?.country?.name} />
											) : (
												'---'
											)}
										</p>
									)}
								</div>
								<div className="contact-detail-item">
									<label>Billing Address </label>
									{isLoading ? (
										<div style={{ width: '160px' }}>
											<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
										</div>
									) : (
										<p>
											{contactInfo?.address?.address}, {contactInfo?.address?.city}, {contactInfo?.address?.zipcode} <br />
											{contactInfo?.address?.country?.name}
										</p>
									)}
								</div>
								<div className="contact-detail-item">
									<label>Shipping Address </label>
									{isLoading ? (
										<div style={{ width: '160px' }}>
											<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
										</div>
									) : (
										<p>
											{contactInfo?.shipping?.address}, {contactInfo?.shipping?.city}, {contactInfo?.shipping?.zipcode} <br />
											{contactInfo?.shipping?.country?.name}
										</p>
									)}
								</div>

								{!isLoading && (
									<div className="contact-detail-section">
										<div className="contact-detail-side">
											<div className="contact-cps">
												<div className="contact-cp">
													<label className="cp-key">Contact 01</label>
													<p className="cp-name">
														<PrivacyModeContent>{contactInfo?.contact_name || '-'}</PrivacyModeContent>
													</p>
													<p className="cp-email">
														<PrivacyModeContent>{contactInfo?.email || '-'}</PrivacyModeContent>
													</p>
													<p className="cp-mobile">
														<PrivacyModeContent>{contactInfo?.contact_phone || '-'}</PrivacyModeContent>
													</p>

													<div className="contact-cp-actions">
														<a href={contactInfo?.contact_phone ? 'tel:' + contactInfo?.contact_phone : '#'} target="_blank">
															<span className="btnEdit plain-iconbtn contact-cp-buttons">
																<LuPhone size={isMobile ? 18 : 12} />
															</span>
														</a>
														<a
															href={contactInfo?.contact_whatsapp ? 'https://wa.me/' + contactInfo?.contact_whatsapp?.replace('+', '') : '#'}
														>
															<span className="btnEdit plain-iconbtn contact-cp-buttons">
																<FaWhatsapp size={isMobile ? 18 : 12} />
															</span>
														</a>
														<a href={contactInfo?.email ? 'mailto:' + contactInfo?.email : '#'} target="_blank">
															<span className="btnEdit plain-iconbtn contact-cp-buttons">
																<MdOutlineMailOutline size={isMobile ? 18 : 12} />
															</span>
														</a>
													</div>
												</div>
											</div>
										</div>
									</div>
								)}
							</div>
						)}

						{(!isMobile || (isMobile && selectedMobileTab === 'business')) && (
							<div style={{ marginTop: 5, marginLeft: 20, marginRight: 20, marginBottom: 5 }}>
								<ReactSelect
									value={{
										value: activeTab,
										label:
												activeTab === 'stats' ? 'Stats'
												: activeTab === 'Quotations' ? 'Quotations'
												: activeTab === 'Invoices' ? 'Invoices'
												: activeTab === 'Sales Orders' ? 'Sales Orders'
												: activeTab === 'Documents' ? 'Documents'
												: activeTab === 'History' ? 'History'
												: activeTab === 'Credit Notes' ? 'Credit Notes'
												: activeTab === 'Purchase Orders' ? 'Purchase Orders'
												: activeTab
									}}
									onChange={(option) => handleTab(option.value)}
									options={[
										{ value: 'stats', label: 'Stats' },
										...(contactInfo?.contact_type !== 'supplier'
											? [
												{ value: 'Sales Orders', label: 'Sales Orders' },
												{ value: 'Invoices', label: 'Invoices' },
												{ value: 'Credit Notes', label: 'Credit Notes' },
												{ value: 'Documents', label: 'Documents' },
												{ value: 'History', label: 'History' },
												{ value: 'Documents', label: 'Documents' },
												{ value: 'History', label: 'History' },
											] : [
												{ value: 'Purchase Orders', label: 'Purchase Orders' },
												{ value: 'Documents', label: 'Documents' },
												{ value: 'History', label: 'History' },
											]),
									
									]}
									isDisabled={isLoading}
									styles={{
										control: (base, state) => ({
											...base,
											background: '#f5f5f5',
											borderColor: '#e0e0e0',
											minHeight: 38,
											borderRadius: 8,
											boxShadow: state.isFocused ? '0 0 0 1px #bdbdbd' : base.boxShadow,
											color: '#333'
										}),
										singleValue: (base) => ({
											...base,
											color: '#333'
										}),
										menu: (base) => ({
											...base,
											zIndex: 9999
										})
									}}
									isSearchable={false}
								/>
							</div>
						)}
					</div>

					{selectedMobileTab === 'business' ? (
						<div className="mobile-scroll-container mobile-scroll-container-smaller no-padding-inline" style={{ width: '100%' }}>
							{activeTab === 'stats' && (
								<StatsTabComponent id={id} contactType={contactInfo?.contact_type} />
							)}
							{activeTab == 'Quotations' ? (
								<QuotationTabComponent id={contactInfo?.id} />
							) : activeTab == 'Invoices' ? (
								<InvoiceTabComponent id={contactInfo?.id} />
							) : activeTab == 'Sales Orders' ? (
								<SalesOrderTabComponent id={contactInfo?.id} />
							) : activeTab == 'Documents' ? (
								<DocumentTabComponent attachments={contactInfo?.attachments} />
							) : activeTab == 'Credit Notes' ? (
								<CreditNotesTabComponent id={contactInfo?.id} />
							) : null
							}
						</div>
					) : null}
				</div>
			)}

			<Modal show={show} onHide={handleClose} centered>
				<Modal.Body>
					<Modal.Title>Confirm Delete</Modal.Title>
					<p>Are you sure you want to delete {`${show.name}`}</p>
					<Button variant="primary" className="m-2 " onClick={handleClose}>
						Cancel
					</Button>
					<Button
						variant="danger"
						className="m-2"
						onClick={(e) => {
							handleDelete(show.id);
						}}
					>
						Delete
					</Button>
				</Modal.Body>
			</Modal>
			{showPortal && <ClientPortalModel show={showPortal} handleConfirm={handleClientPortalSubmit} handleClose={handleClosePortal} />}
			{confirmationDialog?.show && (
				<ActionConfirmationModal
					show={confirmationDialog?.show}
					message={confirmationDialog?.message}
					title={confirmationDialog?.title}
					customConfirmText={confirmationDialog?.customConfirm || 'Confirm'}
					customCancelText={confirmationDialog?.customCancel || 'Cancel'}
					customIcon={<PiInfoFill />}
					handleConfirm={confirmationDialog?.handleConfirm}
					handleClose={confirmationDialog?.handleClose}
				/>
			)}
		</>
	);
};

export default ContactDetails;
